<template>
  <div id="app">
    <div class="meme">
      <img :src="imageUrl" alt="meme" @click="nextImage" />
      <a class="button is-warning" href="https://workbench.ameo.io">zur Workbench</a>
    </div>
  </div>
</template>

<style lang="scss">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

@import "~flag-icon-css/css/flag-icon.min.css";

@import "~bulma/sass/utilities/_all";

$gap: 16px;

// $block-spacing: 0.75rem;
// $column-gap: $block-spacing / 2;

// $box-padding: 0.75rem;

// $section-padding: 1rem 0.25rem;

@import "~bulma";
@import "~buefy/src/scss/buefy";

// .column .columns:not(:last-child) {
//   margin-bottom: #{$block-spacing - $column-gap};
// }

.box {
  border-radius: 0;
}

.meme img {
  max-height: 400px;
  margin: 5em auto;
  display: block;
  cursor: pointer;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}
.meme a {
  margin: 5em auto;
  display: block;
  width: 200px;
}
</style>
<script>
import Vue from "vue";
import Component from "vue-class-component";

function randomImage() {
  return "/image_" + Math.floor(Math.random() * 6) + ".png";
}

@Component({
  data() {
    return {
      imageUrl: randomImage()
    };
  },
  methods: {
    async nextImage() {
      this.imageUrl = randomImage();
    }
  }
})
export default class App extends Vue {}
</script>
